import { EnumSchema, Executor, FromSchema, ZodDate } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { ComplyAdvantageStatus } from './comply-advantage.status.enum';
import { BusinessMatch, BusinessMatchSchema } from '@40seas/entities/match';

export const ComplyAdvantageSchema = WithBaseEntitySchema(
    z.object({
        buyer: z.string(),
        companyId: z.string(),
        address: z.string(),
        jurisdictionCode: z.string(),
        name: z.string(),
        companyStatus: EnumSchema(ComplyAdvantageStatus),

        caseId: z.string().optional(),
        screeningId: z.string().optional(),

        companyType: z.string().optional(),
        businessStartDate: ZodDate.optional(),
        match: BusinessMatchSchema.nullish(),
    }),
).strict();

export class ComplyAdvantage extends FromSchema(ComplyAdvantageSchema) implements BaseEntity {
    id: string;
    buyer: string;
    companyId: string;
    companyStatus: ComplyAdvantageStatus;
    jurisdictionCode: string;
    address: string;
    name: string;
    match?: BusinessMatch;

    caseId?: string;
    screeningId?: string;

    companyType?: string;
    businessStartDate?: Date;

    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}

export class MultiTenantComplyAdvantage extends ComplyAdvantage {}
